import {AuthToken} from '../../interfaces/core/auth-token';

export class AuthTokenFactory {

  /**
   *
   * @param authToken
   */
  public static fromObject(authToken: any): AuthToken {
    return new class implements AuthToken {
      expires: string = authToken.expires;
      token: string = authToken.token;
      userId: number = authToken.user_id;
    };
  }

}
